import { AgentAPIcaller } from './externalAPICallers/AgentAPIcaller';

const getConversations = () => AgentAPIcaller.apiGet('/conversations');

const getConversationMessages = (conversationId) =>
  AgentAPIcaller.apiGet(`/conversations/${conversationId}/messages`);

const sendMessage = (message) =>
  AgentAPIcaller.apiPost(`/message`, message, { responseType: 'json', timeout: 1800000 });

const sendMessageStream = (message, onEvent) =>
  AgentAPIcaller.apiStreamPost(`/message/stream`, message, onEvent);

const deleteConversation = (conversationId) =>
  AgentAPIcaller.apiDelete(`/conversations/${conversationId}`);

const updateConversation = (conversation) =>
  AgentAPIcaller.apiPut(`/conversations/${conversation.id}`, conversation);

const sendFeedBack = (feedback) => AgentAPIcaller.apiPost(`/feedback`, feedback);

const retryMessage = (messageId, currencyCode, enabledFeaturePaths) =>
  AgentAPIcaller.apiPost(`/message/retry`, {
    message_id: messageId,
    currency_code: currencyCode,
    enabled_feature_paths: enabledFeaturePaths,
  });

export default {
  getConversations,
  getConversationMessages,
  sendMessage,
  sendMessageStream,
  deleteConversation,
  sendFeedBack,
  updateConversation,
  retryMessage,
};
